/*
 *		Copyright (c) 2011-2021 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .factory('EmailTools', [function () {
        var emailPattern = '(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))';
        var validationPattern = new RegExp('^' + emailPattern + '$', 'gi');
        var extractionPattern = new RegExp(emailPattern, 'gi');

        return {
            getEmailPattern: function () {
                return emailPattern;
            },
            isValid: function (email) {
                return (email || '').search(validationPattern) === 0;
            },
            extractMail: function (text) {
                return (text || '').match(extractionPattern) || [];
            }
        }
    }]);
